import styled from "styled-components"
import { ReactComponent as ExclamationIcon } from "images/icons/circle-exclamation.svg"
import { theme } from "../../../theme"

export const Header = styled.div`
  margin-bottom: 2rem;

  ${theme.mQ.MEDIA_MIN_LARGE} {
    display: flex;
    justify-content: space-between;
  }
`

export const TopContainer = styled.div`
width: 100%;
  display: flex;
  justify-content: space-between;

`

export const AcademyButton = styled.a`
  border: 0.1rem solid ${p => p.theme.colors.borderLight};
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.6rem;
  background-color: ${p => p.theme.colors.greyLighter};
  svg {
    height: 1.6rem;
  }

  &:hover {
    background-color: ${p => p.theme.colors.grey};

    svg {
      fill: ${p => p.theme.colors.white};
    }
  }
`

export const EditWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-end;

  span {
    display: flex;
    align-items: center;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  button {
    font-size: 1.1rem;
    margin-left: 1rem;
  }
`

export const ActionButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0 0.5rem 1rem;
`

export const Container = styled.div`
  margin-top: 3rem;
  background-color: ${(p) => p.theme.colors.greyLighter};
  padding: 2rem;
  border-radius: 0.6rem;
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};

  h1 {
    margin: 0;
  }

  .react-tabs {
    -webkit-tap-highlight-color: transparent;
  }
`

export const Id = styled.div`
  display: flex;
  align-items: center;

  span {
    font-size: 1.3rem;
    text-decoration: underline;
    color: ${(p) => p.theme.colors.greyDark};
    margin: 0;
  }
`

export const MerchantRef = styled(Id)`
  span:first-child {
    text-decoration: none;
    margin-right: 0.3rem;
  }
`

export const Columns = styled.div`
  ul {
    grid-template-columns: repeat(3, 1fr);
  }
`

export const NoticeWrapper = styled.div`
  display: flex;

  span {
    display: flex;
    position: absolute;
    right: 2rem;

    svg {
      fill: ${(p) => p.theme.colors.black};
      margin: 0 0.5rem 0 0;
      display: flex;
      align-items: center;
    }

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
`

export const TabAlert = styled(ExclamationIcon)`
  height: 1.2rem;
  width: 1.2rem;
  position: absolute;
  fill: ${(p) => p.theme.colors.error.background};
`

export const TabsContainer = styled.div`
  .react-tabs__tab-list {
    margin: 0;
    padding: 0.8rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    text-align: center;
    background: ${(p) => p.theme.colors.greyLightest};
    border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
    border-radius: 0.6rem;

    ${theme.mQ.MEDIA_MIN_LARGE} {
      display: flex;
      margin: 0;
    }
  }

  .react-tabs__tab {
    display: inline-block;
    border: none;
    bottom: -1px;
    position: relative;
    list-style: none;
    padding: 0 1.5rem;
    cursor: pointer;
    font-size: 1.4rem;
    border-radius: 0.6rem;
    color: ${(p) => p.theme.colors.greyDark};

    ${theme.mQ.MEDIA_MIN_LARGE} {
      font-size: 1.2rem;
      border-bottom: none;
    }
  }

  .react-tabs__tab--selected {
    border: none;
    background: ${(p) => p.theme.colors.greyLight};
    color: ${theme.colors.black};
  }

  .react-tabs__tab--disabled {
    color: GrayText;
    cursor: default;
  }

  .react-tabs__tab:focus {
    outline: none;
  }

  .react-tabs__tab:focus:after {
    display: none;
  }

  .react-tabs__tab-panel {
    display: none;
  }

  .react-tabs__tab-panel--selected {
    display: block;
  }
`

export const TabListWrapper = styled.div`
  background: ${theme.colors.white};
  padding: 2.5rem;
  margin-bottom: 3rem;
  border-radius: 0.6rem;
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
`
